export const REGIONS = [
	["Australia", -24.668163, 134.150929, "AU"],
	["New Zealand", -41.837112, 172.793343, "NZ"],
	["United Kingdom", 54.260582, -1.979057, "GB"],
	["United States of America", 39.999733, -98.678503, "US"],
	["Mexico", 22.77552, -102.57254, "MX"],
	["Colombia", 3.374742, -74.8013, "CO"],
	["Spain", 41.349148, -3.242865, "ES"],
	["Argentina", -31.419014, -64.192828, "AR"],
	["Peru", -9.788561, -75.516214, "PE"],
	["Venezuela", 7.076774, -66.091605, "VE"],
	["Chile", -34.572976, -71.095732, "CL"],
	["Guatemala", 15.609342, -90.560029, "GT"],
	["Ecuador", -1.519327, -78.356744, "EC"],
	["Bolivia", -17.862018, -64.30772, "BO"],
	["Cuba", 21.327181, -77.822863, "CU"],
	["Dominican Republic", 18.892313, -70.086478, "DO"],
	["Honduras", 14.504704, -87.225643, "HN"],
	["Paraguay", -23.487637, -58.305235, "PY"],
	["El Salvador", 13.539026, -88.912394, "SV"],
	["Nicaragua", 12.139432, -84.908726, "NI"],
	["Costa Rica", 9.641263, -83.917331, "CR"],
	["Panama", 8.641033, -80.40586, "PA"],
	["Uruguay", -33.242188, -56.011651, "UY"],
	["Equatorial Guinea", 1.754489, 10.132435, "GQ"],
	["Democratic Republic of the Congo", -1.471684, 23.213382, "CD"],
	["France", 46.263615, 2.178741, "FR"],
	["Canada", 58.111966, -102.032381, "CA"],
	["Madagascar", -19.863362, 46.526251, "MG"],
	["Cameroon", 5.732121, 10.908544, "CM"],
	["Côte d'Ivoire", 7.547363, -5.566505, "CI"],
	["Niger", 9.513243, 8.089456, "NE"],
	["Senegal", 14.502785, -14.654668, "SN"],
	["Chad", 15.195064, 18.842802, "TD"],
	["Guinea", 10.428156, -10.99111, "GN"],
	["Rwanda", -2.002724, 30.010918, "RW"],
	["Belgium", 50.615334, 4.524691, "BE"],
	["Burundi", -3.409225, 29.974677, "BI"],
	["Benin", 9.339155, 2.626981, "BJ"],
	["Haiti", 18.964026, -71.997441, "HT"],
	["Switzerland", 46.910128, 8.416495, "CH"],
	["Togo", 8.561699, 0.974885, "TG"],
	["Central African Republic", 4.382328, 18.559633, "CF"],
	["Congo", -0.22949, 15.935776, "CG"],
	["Gabon", -1.343877, 11.721494, "GA"],
	["Djibouti", 11.753348, 42.638426, "DJ"],
	["Comoros", -12.226076, 44.410906, "KM"],
	["Luxembourg", 49.608384, 6.135195, "LU"],
	["Vanuatu", -15.376706, 166.959158, "VU"],
	["Seychelles", -4.677849, 55.467183, "SC"],
	["Monaco", 43.73333, 7.41667, "MC"],
	["Finland", 64.017562, 26.623533, "FI"],
	["Sweden", 62.687783, 15.349523, "SE"],
	["Åland", 60.546457, 19.947512, "AX"],
	["Antigua and Barbuda", 17.060816, -61.796428, "AG"],
	["The Bahamas", 50.467103, -3.542833, "BS"],
	["Barbados", 13.169025, -59.555144, "BB"],
	["Belize", 17.024106, -88.74177, "BZ"],
	["Botswana", -22.270514, 24.254831, "BW"],
	["Dominica", 15.397731, -61.360261, "DM"],
	["Eswatini", -26.564709, 31.501492, "SZ"],
	["Fiji", -17.792993, 177.984807, "FJ"],
	["The Gambia", 13.437437, -15.51614, "GM"],
	["Ghana", 7.372686, -1.368372, "GH"],
	["Grenada", 12.155863, -61.654958, "GD"],
	["Guyana", 4.633369, -58.801275, "GY"],
	["India", 23.041173, 78.891806, "IN"],
	["Republic of Ireland", 53.422433, -7.929837, "IE"],
	["Jamaica", 18.115368, -77.160905, "JM"],
	["Kenya", 0.500765, 37.609136, "KE"],
	["Kiribati", 2.002841, -157.391854, "KI"],
	["Lesotho", -29.709284, 28.179611, "LS"],
	["Liberia", 6.359217, -9.717986, "LR"],
	["Malawi", -13.302212, 34.036726, "MW"],
	["Malta", 35.948946, 14.413867, "MT"],
	["Marshall Islands", 9.39583, 167.475819, "MH"],
	["Federated States of Micronesia", 6.888581, 158.243484, "FM"],
	["Namibia", -21.99025, 17.175129, "NA"],
	["Nauru", -0.528747, 166.935421, "NR"],
	["Nigeria", 9.513243, 8.089456, "NG"],
	["Pakistan", 30.335127, 69.365084, "PK"],
	["Palau", -5.095382, 159.404011, "PW"],
	["Papua New Guinea", -6.269095, 143.940287, "PG"],
	["Philippines", 14.435947, 121.024297, "PH"],
	["Saint Kitts and Nevis", 17.315342, -62.744355, "KN"],
	["Saint Lucia", 13.895288, -60.964518, "LC"],
	["Saint Vincent and the Grenadines", 13.251501, -61.189064, "VC"],
	["Samoa", -13.621469, -172.438935, "WS"],
	["Sierra Leone", 8.516352, -11.852796, "SL"],
	["Singapore", 1.304374, 103.82458, "SG"],
	["Solomon Islands", -9.645712, 160.156195, "SB"],
	["South Africa", -26.11617, 28.001226, "ZA"],
	["South Sudan", 4.852888, 31.6033, "SS"],
	["Sudan", 15.641276, 32.531116, "SD"],
	["Tanzania", -6.453096, 34.894539, "TZ"],
	["Tonga", -21.167665, -175.27284, "TO"],
	["Trinidad and Tobago", 10.485968, -61.255908, "TT"],
	["Tuvalu", -8.520721, 179.198109, "TV"],
	["Uganda", 1.105402, 32.52062, "UG"],
	["Zambia", -14.31191, 28.23479, "ZM"],
	["Zimbabwe", -19.16669, 29.516362, "ZW"],
	["Germany", 51.209439, 10.457347, "DE"],
	["Austria", 47.648, 14.844832, "AT"],
	["Liechtenstein", 47.160282, 9.540952, "LI"],
	["South Tyrol", 46.672205, 11.159386, ""],
	["Croatia", 45.334021, 15.738636, "HR"],
	["Bosnia and Herzegovina", 44.12213, 18.11715, "BA"],
	["Montenegro", 42.804508, 19.223085, "ME"],
	["Serbia", 44.015665, 20.906401, "RS"],
	["Poland", 52.129535, 19.394454, "PL"],
	["Netherlands", 52.637082, 5.673591, "NL"],
	["Suriname", 5.831058, -55.159137, "SR"],
	["Greece", 38.894822, 22.431347, "GR"],
	["Cyprus", 35.130126, 33.433356, "CY"],
	["Akrotiri and Dhekelia", 35.130126, 33.433356, ""],
	["Indonesia", -3.104976, 119.854142, "ID"],
	["North Macedonia", 41.638192, 21.731396, "MK"],
	["Turkey", 39.061415, 35.124582, "TR"],
	["Sri Lanka", 7.517242, 80.779494, "LK"],
	["Thailand", 15.660392, 101.520053, "TH"],
	["Russia", 61.987429, 96.714855, "RU"],
	["Belarus", 53.518236, 28.143867, "BY"],
	["Kazakhastan", 47.827276, 67.382857, "KZ"],
	["Kyrgyzstan", 41.464025, 74.555223, "KG"],
	["Tajikistan", 39.834832, 70.634386, "TJ"],
	["Algeria", 36.755589, 2.977719, "DZ"],
	["Bahrain", 25.995459, 50.588295, "BH"],
	["Egypt", 26.561996, 31.688555, "EG"],
	["Iraq", 33.139266, 42.802917, "IQ"],
	["Jordan", 31.12573, 36.392121, "JO"],
	["Kuwait", 29.360775, 47.633578, "KW"],
	["Lebanon", 34.191738, 35.887572, "LB"],
	["Libya", 26.768524, 17.50665, "LY"],
	["Mali", 12.646173, -8.001725, "ML"],
	["Mauritania", 18.557723, -11.424025, "MR"],
	["Morocco", 31.713478, -6.483976, "MA"],
	["Oman", 20.022785, 56.381535, "OM"],
	["State of Palestine", 33.295379, 44.322663, "PS"],
	["Qatar", 25.525388, 51.217536, "QA"],
	["Saudi Arabia", 24.638192, 46.710174, "SA"],
	["Somalia", 5.432381, 47.079905, "SO"],
	["Syria", 36.216663, 37.125963, "SY"],
	["Tunisia", 36.79743, 10.181769, "TN"],
	["United Arab Emirates", 25.269233, 55.307583, "AE"],
	["Yemen", 15.744086, 47.66645, "YE"],
	["Somaliland", 9.560553, 44.050861, "SO"],
	["Zanzibar", -6.163746, 39.192246, ""],
	["Sahrawi Arab Democratic Republic", -6.778218, 39.26547, ""],
	["Japan", 35.672792, 136.690816, "JP"],
	["Danish Realm", 54.479526, 10.118472, ""],
	["South Korea", 36.458351, 127.855841, "KR"],
	["North Korea", 39.930034, 126.549792, "KP"],
	["China", 35.86002, 104.165802, "CN"],
	["Taiwan", 23.709623, 120.543601, "TW"],
	["Romania", 44.445441, 26.111523, "RO"],
	["Moldova", 47.505003, 28.366633, "MD"],
	["Transnistria", 46.846795, 29.60908, ""],
	["Azerbaijan", 40.352954, 47.772974, "AZ"],
	["Dagestan", 42.980918, 47.499902, ""],
	["Kosovo", 42.571109, 20.959413, ""],
	["Italy", 42.672999, 12.592684, "IT"],
	["San Marino", 43.936298, 12.445685, "SM"],
	["Vatican City", 41.903148, 12.453801, "VA"],
	["Czech Republic", 41.9041, 12.499711, "CZ"],
	["Vietnam", 13.318655, 108.3681, "VN"],
	["Lithuania", 55.336438, 23.896703, "LT"],
	["Hungary", 47.045058, 19.375867, "HU"],
	["Slovenia", 46.138462, 14.987427, "SI"],
	["Norway", 61.457979, 8.971401, "NO"],
	["Bulgaria", 42.668565, 25.412718, "BG"],
	["Brunei", 4.538105, 114.748453, "BN"],
	["Malaysia", 3.101033, 101.627546, "MY"],
	["Slovakia", 48.746119, 19.67294, "SK"],
	["Vojvodina", 45.532663, 20.00334, ""],
	["Latvia", 56.856496, 24.915373, "LV"],
	["Ukraine", 48.907372, 31.722114, "UA"],
	["Brazil", -9.683469, -52.308555, "BR"],
	["Mozambique", -18.145428, 35.341997, "MZ"],
	["Angola", -12.286385, 17.762631, "AO"],
	["Portugal", 39.306285, -8.003141, "PT"],
	["East Timor", -8.819164, 125.865833, "TL"],
	["Guinea-Bissau", 11.852992, -15.602996, "GW"],
	["Macau", 45.009226, -0.612073, "MO"],
	["Cape Verde", 16.004192, -24.009817, "CV"],
	["São Tomé and Príncipe", 0.219483, 6.597725, "ST"],
	["Estonia", 58.674419, 25.394371, "EE"],
	["Iran", 32.815273, 53.487766, "IR"],
	["Afghanistan", 33.828685, 65.658159, "AF"],
	// manually added regions
	["Antarctica", -82.862752, 135.0, "AQ"], // Antarctica has only one research station (primary english speaking) - so supported due to obvious reasons
] as const;

type Arc = {
	startLat: number;
	startLng: number;
	endLat: number;
	endLng: number;
	color: string;
};
export function generateArcsData(): Arc[] {
	let arcsData: Arc[] = [];
	for (let region of REGIONS) {
		const randomRegion = REGIONS[Math.round(Math.random() * (REGIONS.length - 1))];
		arcsData.push({
			startLat: region[1],
			startLng: region[2],
			endLat: randomRegion[1],
			endLng: randomRegion[2],
			color: "#dfad6c",
		});
	}
	return arcsData;
}

type Label = {
	lat: number;
	lng: number;
	text: string;
	color: string;
};
export function generateLablesData(): Label[] {
	let labelsData: Label[] = [];
	for (let region of REGIONS) {
		labelsData.push({
			lat: region[1],
			lng: region[2],
			text: region[0],
			color: "#ffffff",
		});
	}
	return labelsData;
}
